import crud from '@/crud/index/index'
import resources from '../../resources'
import methods from './methods'

import components from './components'
import computed from './computed'

export default {
  components,
  methods,
  computed,
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/tenant/book-occurrence/index/resources/index.js